<template>
  <div>
    <div class="dashboard-info-widgets d-flex justify-content-around flex-column flex-md-row">

      <!-- Screenings -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-calendar stats-icon icon-wide"></i>
              <count v-if="screenings >= 0" :to="screenings"></count>
              <span v-else v-text="screenings"></span>
            </div>
            <div class="stats-title"> {{ $t('agenda.statistics.screenings') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- Number Promoters -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-user stats-icon icon-wide"></i>
              <count v-if="promoters >= 0" :to="promoters"></count>
              <span v-else v-text="promoters"></span>
            </div>
            <div class="stats-title">{{ $t('agenda.statistics.promoters') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- Number appointments -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-list-ul stats-icon icon-wide"></i>
              <count v-if="appointments >= 0" :to="appointments"></count>
              <span v-else v-text="appointments"></span>
            </div>
            <div class="stats-title">{{ $t('agenda.statistics.appointments') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- Number screenings cancelled -->
      <va-card class="info-widget brand-info" v-if="isFromEvollu">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <!--<i class="fa fa-trash stats-icon icon-wide"></i>-->
              <i class="va-icon fa fa-calendar-times-o mr-1" style="font-size: 1.7rem;"></i>
              <count v-if="screenings_cancelled >= 0" :to="screenings_cancelled"></count>
              <span v-else v-text="screenings_cancelled"></span>
            </div>
            <div class="stats-title">
              {{$t('agenda.statistics.screenings_cancelled')}}
            </div>
          </div>
        </div>
      </va-card>
    </div>
    <div class="dashboard-info-widgets d-flex justify-content-around flex-column flex-md-row">
      <!-- Number submitted -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-bullseye stats-icon icon-wide"></i>
              <count v-if="contacts >= 0" :to="contacts"></count>
              <span v-else v-text="contacts"></span>
            </div>
            <div class="stats-title"> {{ $t('agenda.statistics.contacts') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- Number submitted with loss -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-deaf stats-icon icon-wide"></i>
              <count v-if="contactsWithLoss >= 0" :to="contactsWithLoss"></count>
              <span v-else v-text="contactsWithLoss"></span>
            </div>
            <div class="stats-title"> {{$t('agenda.statistics.contacts_with_loss')}}
            </div>
          </div>
        </div>
      </va-card>

      <!-- LQ per Screening -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-pie-chart stats-icon icon-wide"></i>
              <count v-if="avgContactsWithLossPerScreening >= 0" :to="avgContactsWithLossPerScreening"></count>
              <span v-else v-text="avgContactsWithLossPerScreening"></span>
            </div>
            <div class="stats-title">{{ $t('agenda.statistics.avg') }}
            </div>
          </div>
        </div>
      </va-card>

      <!-- Number LQE -->
      <va-card class="info-widget brand-info">
        <div class="info-widget-inner">
          <div class="stats">
            <div class="stats-number">
              <i class="fa fa-check stats-icon icon-wide"></i>
              <count v-if="leads >= 0" :to="leads"></count>
              <span v-else v-text="leads"></span>
            </div>
            <div class="stats-title"> {{$t('agenda.statistics.leads_qualified')}}
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import Count from '@/components/common/Count'
import IsFromEvollu from '@/mixins/IsFromEvolluMixin'
export default {
  name: 'dashboard-info-widgets',
  components: {
    Count
  },
  mixins: [IsFromEvollu],
  props: {
    contacts: {
      type: Number,
      required: true
    },
    contactsWithLoss: {
      type: Number,
      required: true
    },
    leads: {
      type: Number,
      required: true
    },
    screenings: {
      type: Number,
      required: true
    },
    promoters: {
      type: Number,
      required: true
    },
    appointments: {
      type: Number,
      required: false,
      default: 0
    },
    screenings_cancelled: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    avgContactsWithLossPerScreening: function () {
      if (this.screenings > 0 && this.contacts > 0) {
        return parseFloat((this.contactsWithLoss / this.screenings).toFixed(1))
      }
      return 0
    }
  }
}
</script>

<style lang="scss">
.widget.brand-info {
  box-shadow: 0px 0px 0px #29c4a9;
}

</style>
<style lang="scss" scoped>

.info-widget{
  flex-basis: 20%;
}

.stats-number, .stats-title {
  line-height: 1;
}

.info-widget-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;

  &.has-chart {
    justify-content: space-between;
  }

  .stats {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}

.stats-number {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 2.625rem;
  margin-bottom: 0.5rem;

  .stats-icon {
    font-size: 1.5625rem;
    position: absolute;
    top: 0.625rem;
    left: -1.25rem;

    &.icon-wide {
      left: -1.875rem;
    }
  }
}
</style>
